//@flow
import { type stateType } from "./reducer";

export const getNotifications = (state: stateType) => state.notifications;
